import { Col, Row } from 'antd';
import React from 'react';
import { useParams } from 'react-router';

import { useGetVariantDetailQuery } from '../../api/variantApi';
import DetailCard from '../components/DetailCard';
import VariantUpdatePrimaryTranscript from '../components/VariantUpdatePrimaryTranscript';
import { VARIANT_STAGE_TYPES } from '../constants';
import { useVariantStep } from '../hooks/use_variant_step';
import Interpretation from '../interpretation/Interpretation';
import FrequentPathogenicVariantSection from './FrequentPathogenicVariantSection';
import MaximumCredibleSection from './MaximumCredibleSection';
import PopulationSection from './PopulationSection';

const FrequencyData = () => {
  const params = useParams();

  // Read the selected variant straight from the RTK Query cache (populated
  // by the workflow loader) rather than a Redux selector.
  const { data: variant } = useGetVariantDetailQuery(
    { variant_id: params.vid },
    { skip: !params.vid },
  );

  const stageInfo = useVariantStep(VARIANT_STAGE_TYPES.FREQUENCY_DATA);

  return (
    <div className="frequency-data">
      <VariantUpdatePrimaryTranscript />
      <Row gutter={[8, 8]} className="workflow-stage-content-container">
        <Col flex={'auto'} className="workflow-stage-left-col">
          <DetailCard>
            <PopulationSection />
          </DetailCard>
          <DetailCard>
            <h3>Significance of allele frequency for condition of interest</h3>
            <FrequentPathogenicVariantSection />
            <MaximumCredibleSection />
          </DetailCard>
        </Col>

        {stageInfo && variant && (
          <Interpretation
            variant={variant}
            stepLabel="Frequency Data"
            stepStatus={stageInfo.status}
            stepId={stageInfo.id}
            stepType={stageInfo.stage_type}
          />
        )}
      </Row>
    </div>
  );
};

export default FrequencyData;
